(ns global.endor.checkout.stripe.ui
  (:require
   ["@phosphor-icons/react" :as phosphor]
   ["@stripe/react-stripe-js/checkout" :as react-stripe-checkout]
   ["react-phone-number-input" :as react-phone-input]
   [cljs-bean.core :as bean :refer [->clj]]
   [global.endor.checkout.ui.components.basics :refer [column row text]]
   [global.endor.checkout.ui.components.button :as button]
   [global.endor.checkout.ui.components.select :as select]
   [global.endor.checkout.ui.components.spinner :as spinner]
   [global.endor.checkout.ui.style.base :as base]
   [global.endor.checkout.ui.style.colors :as colors]
   [global.endor.checkout.ui.style.elements :as style]
   [global.endor.checkout.utils :as utils]
   [re-frame.core :as rf]
   [uix.core :as uix :refer [$ defui]]))

(def box-styles
  {:background-color (-> colors/background-sub :secondary :5-percent)
   :padding 20})

(defui container
  [{:keys [children]}]
  ($ column
     {:gap :extra-large
      :style {:background-color (colors/background :primary)
              :max-width 600
              :margin "0 auto"
              :padding "30px 12px"}}
     children))

(do :subcomponents

    (defui switch [{:keys [checked on-change on-color off-color]}]
      ($ :div
         {:on-click (fn [] (on-change (not checked)))
          :style {:width 44
                  :background-color (if checked on-color off-color)
                  :padding 2
                  :border-radius 2}}
         ($ :div
            {:style {:height 20 :width 20
                     :background-color "white"
                     :border-radius 2
                     :margin-left (if checked "auto" 0)
                     :margin-right (if checked 0 "auto")
                     :transition "margin-left 0.3s ease, margin-right 0.3s ease"}})))

    (defui location-selector [{:keys [location-options on-change-location default-value]}]
      ($ select/select
         {:on-change (fn [v] (on-change-location v))
          :placeholder "Select location"
          :options location-options
          :default-value (first (filter #(= (:value %) default-value) location-options))}))

    (defui email-input [{:keys [autofocus value is-valid on-change]}]
      ($ column
         {:gap :medium}
         ($ text {:font :body}
            "Enter your email address")
         ($ row
            {:justify-content "space-between"
             :style {:border "1px solid #666"
                     :border-radius 4
                     :background-color (when-not is-valid (-> colors/background-sub :secondary :10-percent))
                     :padding 16}}
            ($ :input.unstyled-input
               {:type "email"
                :autoFocus autofocus
                :default-value value
                :on-change #(on-change (.. % -target -value))
                :required true
                :style (merge {:background-color "transparent"
                               :color "white"
                               :flex 1
                               :border "none"}
                              (style/font :body))})
            ($ button/icon-button
               {:icon (when is-valid phosphor/Check)
                :size :small
                :color (when is-valid (-> colors/system :success))}))))

    (defui phone-input [{:keys [value is-valid allowed-countries on-change]}]
      ($ :<>
         ($ :style
            {}
            (str ".endor-phone {background-color: transparent;}"
                 ".endor-phone .PhoneInput {display: flex; align-items: center; background-color: transparent; border: none;}"
                 ".endor-phone .PhoneInputCountrySelect {background-color: transparent; border: none; color: rgba(255,255,255,0.9); font-family: Space Grotesk; margin-right: 8px;}"
                 ".endor-phone .PhoneInputCountrySelect:hover {background-color: rgba(255,255,255,0.05);}"
                 ".endor-phone .PhoneInputCountrySelect:focus {background-color: rgba(255,255,255,0.08); outline: none;}"
                 ".endor-phone .PhoneInputCountrySelectArrow {color: rgba(255,255,255,0.6); border-color: rgba(255,255,255,0.6) transparent transparent transparent;}"
                 ".endor-phone .PhoneInputCountryIcon {width: 20px; height: 15px; border-radius: 2px;}"
                 ".endor-phone .PhoneInputInput {background-color: transparent; border: none; color: rgba(255,255,255,0.9); font-family: Space Grotesk; font-size: 14px; outline: none; flex: 1; margin-left: 8px;}"
                 ".endor-phone .PhoneInputInput::placeholder {color: rgba(255,255,255,0.5);}"))
         ($ column
            {:gap :medium}
            ($ text {:font :body}
               "Enter your phone number")
            ($ row
               {:justify-content "space-between"
                :align-items "center"
                :style {:border "1px solid #666"
                        :border-radius 4
                        :background-color (when-not is-valid (-> colors/background-sub :secondary :10-percent))
                        :padding 16}}
               ($ :div
                  {:className "endor-phone"
                   :style {:flex "1"}}
                  ($ react-phone-input/default
                     (merge {:value value
                             :onChange on-change
                             :placeholder "Enter phone number"
                             :defaultCountry (or
                                               ;; 1. Try browser locale country if it's in allowed list
                                              (when-let [detected (utils/detect-country-from-locale)]
                                                (when (or (nil? allowed-countries)
                                                          (empty? allowed-countries)
                                                          (some #(= % detected) allowed-countries))
                                                  detected))
                                               ;; 2. Try timezone country if it's in allowed list
                                              (when-let [timezone-country (utils/detect-country-from-timezone)]
                                                (when (or (nil? allowed-countries)
                                                          (empty? allowed-countries)
                                                          (some #(= % timezone-country) allowed-countries))
                                                  timezone-country))
                                               ;; 3. First allowed country
                                              (when (seq allowed-countries)
                                                (first allowed-countries))
                                               ;; 4. Norway fallback
                                              "NO")
                             :international true}
                            (when (and allowed-countries (seq allowed-countries))
                              {:countries (bean/->js allowed-countries)}))))
               ($ button/icon-button
                  {:icon (when is-valid phosphor/Check)
                   :size :small
                   :color (when is-valid (-> colors/system :success))}))))))

(defui promocode-applied
  [{:keys [on-remove promo-code discount-amount]}]
  ($ column
     ($ row
        {:justify-content "space-between" }
        ($ row
           {:style {:border "1px solid #666"
                    :border-radius 4
                    :padding 16}}
           ($ button/icon-button
              {:size :medium
               :icon phosphor/Tag})
           ($ text promo-code)
           ($ button/icon-button
              {:size :medium
               :icon phosphor/X
               :on-press on-remove}))
        ($ text (str "- " discount-amount)))))

(defui promocode-input
  [{:keys [promo-code promo-error on-apply on-change applying]}]
  (let [error-color (base/colors :fire-red-bright)]
    ($ column
       {:gap :medium}
       ($ text {:font :body}
          "Add promotion code")
       ($ row
          {:justify-content "space-between"
           :style {:border "1px solid #666"
                   :border-radius 4
                   :padding 16}}
          ($ :input.unstyled-input
             {:type "text"
              :value promo-code
              :on-change on-change,
              :required false
              :style (merge {:background-color "transparent"
                             :color (if promo-error error-color "white")
                             :flex 1
                             :border "none"
                             :text-transform "uppercase"}
                            (style/font :body)) })
          (cond
            applying
            ($ spinner/spinner
               {:size 15})

            (and (seq promo-code) (not promo-error))
            ($ button/button
               {:text "Apply",
                :level :tertiary
                :size :small
                :style {:background-color "transparent"
                        :height 22}
                :on-press on-apply})))
       (when promo-error
         ($ text
            {:color error-color}
            promo-error)))))

(defui promocode []
  (let [stripe-checkout (react-stripe-checkout/useCheckout)
        checkout (.-checkout stripe-checkout)
        [input-promo-code set-promo-code] (uix.core/use-state "")
        [applying set-applying] (uix.core/use-state false)
        [removing set-removing] (uix.core/use-state false)
        [promo-error set-promo-error] (uix.core/use-state nil)
        applied-promo-code (:promotionCode (first (:discountAmounts (bean/->clj checkout))))
        discount-amount (:amount (:discount (:total (bean/->clj checkout))))
        on-apply (fn []
                   (set-applying true)
                   (-> (.applyPromotionCode checkout input-promo-code)
                       (.then #(do
                                 (set-applying false)
                                 (set-promo-error (:message (:error (bean/->clj %))))))
                       (.catch #(do
                                  (set-applying false)
                                  (js/console.log "Unexpected error applying promo code:" %)
                                  (set-promo-error "Something went wrong. Please try again.")))))
        on-remove (fn []
                    (set-promo-code nil)
                    (set-removing true)
                    (-> (.removePromotionCode checkout)
                        (.then #(do
                                  (set-removing false)
                                  (set-promo-error (:message (:error  (bean/->clj %))))))
                        (.catch #(do
                                   (set-removing false)
                                   (js/console.log "Unexpected error removing promo code:" %)
                                   (set-promo-error "Something went wrong. Please try again.")))))
        on-change (fn [e]
                    (set-promo-error nil)
                    (set-promo-code (.. e -target -value)))]

    (if (and applied-promo-code (not removing))
      ($ promocode-applied
         {:on-remove on-remove
          :discount-amount discount-amount
          :promo-code applied-promo-code})
      ($ promocode-input
         {:promo-code input-promo-code
          :promo-error promo-error
          :applying applying
          :on-apply on-apply
          :on-change on-change}))))

(do :prices

    (defui product-listing [{:keys [subscription-type]}]
      (let [checkout (->clj (react-stripe-checkout/useCheckout))
            membership-price (-> checkout :checkout :total :subtotal :amount)]
        ($ column
           {:gap :large}
           ($ row
              {:gap :large}
              ($ :img
                 {:style {:height 48
                          :width 48
                          :border-radius 4
                          :padding 8
                          :resize-mode "stretch"
                          :background-color (-> colors/background-sub :secondary :10-percent)}
                  :src "/images/icons/dark.png"})
              ($ column
                 {:gap :extra-small
                  :style {:flex 1}}
                 ($ row
                    {:justify-content "space-between"}
                    (if (= "monthly" subscription-type)
                      ($ text {:font :body} "Free 30 day trial")
                      ($ text {:font :body} "Standard Annual Endor Membership"))
                    ($ text
                       {:font :body}
                       (or membership-price "_")))
                 ($ text {:font :body})))
           ($ row
              {:gap :large}
              ($ :img
                 {:style {:height 48
                          :width 48
                          :border-radius 4
                          :padding 8
                          :resize-mode "stretch"
                          :background-color (-> colors/background-sub :secondary :10-percent)}
                  :src "/images/polar-360.png"})
              ($ column
                 {:gap :extra-small
                  :style {:flex 1}}
                 ($ row
                    {:justify-content "space-between"}
                    ($ text {:font :body} "Polar 360")
                    ($ text {:font :body} "Included"))
                 ($ row
                    {:justify-content "space-between"}
                    ($ text {:font :body :style {:opacity 0.5}} "Qty​ 1")))))))

    (defui order-summary [{:keys [subscription-type]}]
      (let [checkout (->clj (react-stripe-checkout/useCheckout))
            total-price (-> checkout :checkout :total :total :amount)
            renewal-price (-> checkout :checkout :recurring :dueNext :total :amount)]

        ($ column
           {:gap :extra-large}

           (when (not= "monthly" subscription-type)
             ($ promocode))

           ($ column
              {:gap :large}

              ($ row
                 {:justify-content "space-between"}
                 ($ text {:font :body}
                    "Total due today")
                 ($ text {:font :body} (or total-price "_")))

              ($ row
                 {:justify-content "space-between"
                  :style {:opacity 0.5}}
                 ($ text {:font :body}
                    (case subscription-type
                      "monthly" "Renews every 3 months for"
                      "yearly" "Renews annually for"))
                 ($ text {:font :body}
                    renewal-price)))))))

(defui ios-only []
  ($ text {:font :body
           :color "#FFC37F"
           :style {:padding 20}}
     "* Only available for iOS devices"))

(defui header [{:keys [label on-back]}]
  ($ row
     {:justify-content "space-between"}
     ($ phosphor/ArrowLeft
        {:size 24
         :color "white"
         :on-click on-back
         :style {:padding 8}})
     ($ text
        {:font :h4
         :style {:text-align "center"}}
        label)
     ($ :div
        {:style {:width 40}})))

(defui term-agreement [{:keys [accepted set-accepted label description]}]
  ($ column {:gap :medium}
     ($ row
        {}
        (let [icon (if accepted phosphor/CheckSquare phosphor/Square)]
          ($ icon
             {:on-click #(set-accepted not)
              :size 20
              :color "white"}))
        ($ text {:font :small
                 :style {:opacity 0.7}}
           label))
     ($ text {:font :tag
              :style {:opacity 0.5}}
        description)))

(defui device-return-agreement [{:keys [accepted set-accepted]}]
  ($ term-agreement
     {:accepted accepted
      :set-accepted set-accepted
      :label "Agree to the device return terms."
      :description "If I cancel, I agree to return my device within 14 days after the trial ends, otherwise a restocking fee of USD 150 applies"}))

(defui term-of-use-agreement [{:keys [accepted set-accepted subscription-type]}]
  ($ term-agreement
     {:accepted accepted
      :set-accepted set-accepted
      :label "Agree to the Endor Terms of Use"
      :description
      (if (= "monthly"
             subscription-type)
        (list
         "By clicking this box and pressing 'Place order', you agree to the "
         ($ :a
            {:key "link"
             :href "https://www.endor.global/terms-and-conditions"
             :style {:color "white"}}
            "Endor Terms of Use") ". You may cancel at any time during the trial period of 30 days. This is an automatically renewing membership. If not cancelled during the trial period, the membership automatically renews as a 99 USD / 3 month membership, every 3 months.")
        (list "By clicking this box and pressing 'Place order', you agree to the "
              ($ :a
                 {:key "link"
                  :href "https://www.endor.global/terms-and-conditions"
                  :style {:color "white"}}
                 "Endor Terms of Use")
              " and for the membership to automatically renew each year at the annual membership renewal rate. You can cancel at any time through the settings page in the App or by contacting us."))}))

(defui strap-selector [{:keys [limited straps selected-strap]}]
  (let [straps (if limited
                 (take 1 straps)
                 straps)
        {:keys [strap-code] :as selected-strap} (if limited
                                                  (first straps)
                                                  selected-strap)]
    ($ column
       {:gap :large
        :style {}}
       ($ column
          {:gap :large
           :style box-styles}
          (when-not limited
            ($ text {:font :body}
               (if (= strap-code "strap-black-360")
                 "Always included"
                 "Limited time offer. Try our new strap design for free.")))
          ($ :img
             {:style {:width "100%"
                      :aspect-ratio "5/4"
                      :resize-mode "stretch"}
              :src (str
                    "/images/"
                    (:strap-code selected-strap)
                    ".png")})
          ($ row {:style {:justify-content "space-between"}}
             ($ text {:font :body}
                (:strap-text selected-strap))
             ($ phosphor/Check
                {:size 24
                 :color "white"
                 :style {:padding 8}}))
          ($ text {:font :body
                   :style {:opacity 0.5}}
             (:description selected-strap))
          (when-not limited
            ($ row
               (for [{:keys [strap-code strap-color]
                      :as strap} straps
                     :let [selected (= selected-strap strap)]]
                 ($ :div {:key strap-code
                          :on-click #(rf/dispatch [:global.endor.checkout.stripe.core/set-selected-strap strap])
                          :style {:border (if selected
                                            "2px solid #FFC37F"
                                            "2px solid #373737")
                                  :margin 8
                                  :text-align "center"
                                  :width 50 :height 50 :background-color strap-color}}
                    (when selected
                      ($ phosphor/Check
                         {:size 24
                          :color "white"
                          :style {:padding 8
                                  :margin-top 4}}))))))))))

(defui faqs [{:keys []}]
  (let [[expanded set-expanded] (uix/use-state false)
        faqs [{:question "How long is the Trial Membership?"
               :answer "The Trial Membership lasts for 30 days after you log into the Endor App with your code. Make sure to start using Endor when you receive your device, 14 days after you receive it, your 30 days of Trial Membership will start running automatically."}

              {:question "Do I have full access to the Endor App features?"
               :answer "Yes, all Endor App features are available for you as a Trial Member."}

              {:question "What happens after the trial ends?"
               :answer "Unless cancelled before the end of your Trial, your membership will automatically convert into a 3-monthly plan, and you will be billed upfront for 3 months at a time - 33 USD per month (99 USD billed quarterly)."}

              {:question "If I don't like it, how do I cancel?"
               :answer "You can cancel your membership at the settings page in the Endor App, or by contacting our customer success team at post@endor.global."}

              {:question "When do I need to return my device?"
               :answer "You must mail the Device back to Endor within 14 days following the end of your Trial. Please send us the tracking number so we know it's on its way. Note that you must bear the cost of the return shipping."}

              {:question "What happens if I do not return the device?"
               :answer "If you cancel your trial but do not send back the Device within 14 days after the end of your trial, you will be charged a restocking fee of USD 150."}

              {:question "What if I break the Device during my trial?"
               :answer "If you return a broken Device, you will be charged a restocking fee of USD 150. Don't worry, minor cosmetic damage to the sensor and strap are not a problem."}]]
    ($ column {:gap :large}
       ($ column {:gap :large
                  :style box-styles}
          ($ :div {:on-click #(set-expanded not)
                   :style {:display "flex"
                           :cursor "pointer"
                           :justify-content "space-between"}}
             ($ text {:font :h4}
                "Frequently Asked Questions")
             (if expanded
               ($ phosphor/Minus
                  {:size 24
                   :color "white"
                   :style {:padding 8}})
               ($ phosphor/Plus
                  {:size 24
                   :color "white"
                   :style {:padding 8}})))
          (when expanded
            ($ column
               (for [{:keys [question answer]} faqs]
                 ($ column {:key question
                            :style {:padding 20}}
                    ($ text
                       question)
                    ($ text {:font :caption
                             :style {:opacity 0.5}}
                       answer)))))))))

(defui checkout-landing
  [{:keys [location-options
           user-location
           on-change-location
           privacy-terms-accepted
           on-accept-privacy-terms
           selected-strap
           straps
           on-continue
           session-ready
           subscription-type]}]
  (let [[privacy-accepted set-privacy-accepted] (uix.core/use-state privacy-terms-accepted)
        ready? (and privacy-accepted session-ready)]
    ($ column
       {:gap :extra-large}

       ($ text
          {:font :h2
           :style {:text-align "center"
                   :margin-bottom 52}}
          "Start your Endor Journey today")

       ($ column
          {:gap :large
           :style {}}
          ($ column
             {:gap :large
              :style box-styles}
             ($ text {:font :body}
                "Select country")
             ($ location-selector
                {:location-options location-options
                 :on-change-location on-change-location
                 :default-value user-location}))

          ($ strap-selector {:straps straps
                             :selected-strap selected-strap
                             :limited (= user-location "US")})

          ($ :div
             {:style box-styles}
             ($ product-listing
                {:subscription-type subscription-type}))

          ($ column
             {:gap :extra-large
              :style box-styles}

             ;; Need to mount PaymentElement on the same page as promo codes
             ;; otherwise Stripe doesn't apply promocodes in live mode.
             ;; https://docs.stripe.com/disputes/prevention/advanced-fraud-detection
             ;; * in test mode we don't need this hack
             ;; * only one PaymentElement can be mounted on the page
             ($ :div {:style {:display "none"}}
                ($ react-stripe-checkout/PaymentElement))

             ($ order-summary
                {:subscription-type subscription-type})

             ($ term-agreement
                {:accepted privacy-accepted
                 :set-accepted (fn [v]
                                 (set-privacy-accepted v)
                                 (on-accept-privacy-terms v))
                 :label "Agree to the Endor Privacy Policy"
                 :description (list "The Endor Privacy Policy is available for your review "
                                    ($ :a {:key "link"
                                           :href "https://www.endor.global/privacy-policy"
                                           :style {:color "white"}}
                                       "here")
                                    ". By clicking this box and pressing 'Continue', I acknowledge and agree to the Privacy Policy. ")})

             ($ button/button
                {:level (if ready? :primary :secondary)
                 :size :large
                 :text "Continue"
                 :icon phosphor/ArrowRight
                 :style (when-not ready? {:opacity 0.5})
                 :on-press (when ready? on-continue)}))

          ($ ios-only)
          (when (= "monthly"
                   subscription-type)
            ($ faqs))))))

(defui order-details
  [{:keys [location-options on-change-location user-location subscription-type]}]
  ($ column
     {:gap :extra-large
      :style {}}

     ($ location-selector
        {:location-options location-options
         :on-change-location on-change-location
         :default-value user-location})

     ($ product-listing
        {:subscription-type subscription-type})

     ($ :div
        {:style {:border-top "1px solid #666"}})

     ($ order-summary
        {:subscription-type subscription-type})))

(defui checkout-item
  [{:keys [focused complete title children on-next button-text on-focus]}]
  ($ column
     {:gap :extra-large
      :style {:background-color (-> colors/background-sub :secondary :5-percent)
              :padding 20
              :overflow "hidden"
              :max-height (if focused "1300px" "38px")
              :transition (when focused "max-height 0.5s ease-in-out")}}
     ($ :div
        {:on-click on-focus}
        ($ row
           {:justify-content "space-between"}
           ($ text
              {:font :h4}
              title)
           ($ button/icon-button
              {:size :large
               :icon (cond focused phosphor/Eye
                           complete phosphor/Check
                           :else phosphor/EyeClosed)})))
     ($ column
        {:gap :extra-large}
        children

        ($ button/button
           {:level (if complete :primary :secondary)
            :size :large
            :text (or button-text "Next")
            :style (when-not complete {:opacity 0.5})
            :on-press #(when complete
                         (on-next %))}))))

(do :post-payment

    (defui payment-success [{:keys [goto-app-store]}]
      (let [[step set-step] (uix.core/use-state 1)]
        ($ column
           {:align-items "center"
            :gap :2x-large
            :style {:background-color (colors/background :primary)
                    :max-width 400
                    :margin "0 auto"
                    :padding "30px 0px"}}

           ($ text
              {:font :h4
               :style {:text-align "center"}}
              "Success")

           ($ :img
              {:style {:margin "50px"
                       :height 100
                       :width 100
                       :resize-mode "stretch"}
               :src "/images/icons/dark.png"})

           ($ column
              {:gap :2x-large}
              ($ text
                 {:font :h2
                  :style {:text-align "center"}}
                 "Payment successful")

              (case step
                1 ($ column
                     {:gap :large}
                     (map (fn [x]
                            ($ text
                               {:key x
                                :font :body
                                :style {:text-align "center"
                                        :opacity 0.7}}
                               x))
                          ["We are so happy to have you onboard!"
                           "Your Polar 360 device will be on its way soon - we’ll let you know as soon as it ships."
                           "Once you receive your device, you’ll get a unique code to access the Endor Global App."
                           "We can’t wait for you to get started on your Endor journey!"]))
                2 ($ text
                     {:font :body
                      :style {:text-align "center"
                              :opacity 0.7}}
                     "You can download the Endor Global App in App Store, but access is granted through your unique code, that you will receive with your device.")))

           (case step
             1 ($ button/button
                  {:level :secondary
                   :size :large
                   :text "Continue"
                   :on-press #(set-step 2)
                   :icon phosphor/ArrowRight
                   :style {:width "100%"}})

             2 ($ :img
                  {:src "/images/app-store.svg"
                   :on-click goto-app-store
                   :style {:height "auto"
                           :width "100%"
                           :max-width 200}})))))

    (defui payment-failure [{:keys [on-navigate-to-checkout]}]
      ($ column
         {:align-items "center"
          :gap :2x-large
          :style {:background-color (colors/background :primary)
                  :max-width 400
                  :margin "0 auto"
                  :padding "30px 0px"}}

         ($ text
            {:font :h4}
            "Checkout")

         ($ column
            {:gap :2x-large
             :align-items "center"
             :style {:flex 1
                     :margin "auto"}}
            ($ text
               {:font :h1
                :color (colors/system :warning)}
               "Payment Failed")

            ($ text
               {:style {:text-align "center"
                        :opacity 0.7}}
               "Check your payment details to see if there was something wrong."))

         ($ button/button
            {:level :secondary
             :size :large
             :text "Back to checkout"
             :on-press on-navigate-to-checkout
             :style {:width "100%"}})))

    (defui checkout-error [{:keys [error
                                   on-navigate-to-checkout]}]
      ($ column
         {:align-items "center"
          :gap :2x-large
          :style {:background-color (colors/background :primary)
                  :max-width 400
                  :margin "0 auto"
                  :padding "30px 0px"}}

         ($ text
            {:font :h4}
            "Checkout")

         ($ column
            {:gap :2x-large
             :align-items "center"
             :style {:flex 1
                     :margin "auto"}}
            ($ text
               {:font :h1
                :color (colors/system :warning)}
               "Error")

            ($ text
               {:style {:text-align "center"
                        :opacity 0.7}}
               error))

         ($ button/button
            {:level :secondary
             :size :large
             :text "Back to checkout"
             :on-press on-navigate-to-checkout
             :style {:width "100%"}}))))
